import { render, staticRenderFns } from "./HotelRfpQuestionnaireViewSectionRateGrid.vue?vue&type=template&id=458f872e&"
import script from "./HotelRfpQuestionnaireViewSectionRateGrid.vue?vue&type=script&lang=js&"
export * from "./HotelRfpQuestionnaireViewSectionRateGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports